export default __webpack_public_path__ + "static/media/Cart.8b792f98.svg";